const elements = document.querySelectorAll('[data-calendly]')

const clickHandler = (e) => {
  const el = e.target
  document.querySelector('#calendly')?.remove()
  window.history.replaceState({}, '', document.location.pathname)
  if (el.classList.contains('active')) {
    el.classList.remove('active')
    return
  }
  document.querySelector('button.active')?.classList.remove('active')
  const parent = el.closest('.contact, .location')
  if (parent) {
    el.classList.add('active')
    const iframe = document.createElement('iframe')
    iframe.setAttribute('id', 'calendly')
    iframe.setAttribute('src', el.dataset.calendly)
    parent.after(iframe)
    document.location = `${document.location.pathname}#calendly`
  }
}

if (elements.length > 0) {
  for (const el of elements) {
    el.addEventListener('click', clickHandler)
  }
}
